<div class="modal-header2">
  <h4 class="modal-title">Alert</h4>
</div>

<div class="modal-body" style="text-align: center;">
  <p style="margin-top: 40px;">Changes you made will not be saved!</p>

  <div class="btn-align2">
    <button type="button" class="btn btn-default alertbtn alertbtnno" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-default alertbtn alertbtnyes" (click)="onConfirm()">Leave</button>
  </div>
</div>
